























	import Vue from 'vue';
    import BuildFilterButtonComp from "./BuildFilterButtonComp.vue";

    export default Vue.extend({
        name: "BuildFilterButtons",
        components: {BuildFilterButtonComp},
        data: () => ({
            roles: ['P', 'C', 'T', 'H', 'U', 'B'],
            picked: [] as any[],
        }),
        methods: {
            click: function(role: any): void {
                if (!this.isPicked(role)) {
                    this.picked.push(role);
                } else {
                    this.picked = this.picked.filter(r => r !== role);
                }
                this.$emit('setFilter', this.roleString());
            },
            isPicked: function(role: any): boolean {
                return this.picked.indexOf(role) !== -1;
            },
            roleString: function(): string {
                return this.picked.join('');
            },
            reset: function(): void {
                this.picked = [];
                this.$emit('setFilter', this.roleString());
            }
        }
    })
